import noUiSlider from 'nouislider';
import { SELECTORS, SLIDER_DISPLAY_MAPPER, SLIDER_VALUE_MAPPER } from './constants';
import { trackFilterEvent } from './helpers';

function initializeSliderEvents($form) {
  registerSliderEventListeners();

  function registerSliderEventListeners() {
    const slider = $form.find(SELECTORS.SLIDER)[0];
    const sliderInput = document.getElementById(SELECTORS.SLIDER_INPUT_ID);

    if (slider !== undefined) {
      const bonusPointsSlider = initSlider(slider);
      bonusPointsSlider.on('update', sliderOnUpdate);
      bonusPointsSlider.on('change', () => sliderOnChange(bonusPointsSlider, sliderInput));
      $form.on('slider:reset', () => sliderReset(bonusPointsSlider, sliderInput));
      $form.on('slider:setValue', (event, value) => sliderSetValue(bonusPointsSlider, value, sliderInput));
    }
  }

  function initSlider(slider) {
    const sliderOptions = {
      start: [0],
      range: {
        min: [0],
        max: [5],
      },
      step: 1,
      connect: 'lower',
      format: { from: (x => Math.round(x)), to: (x => Math.round(x)) },
    };

    return noUiSlider.create(slider, sliderOptions);
  }

  function sliderOnUpdate(values, handle) {
    const sliderLabel = document.getElementById(SELECTORS.SLIDER_LABEL_ID);
    sliderLabel.innerHTML = SLIDER_DISPLAY_MAPPER[values[handle]];
  }

  function sliderOnChange(slider, sliderInput) {
    sliderInput.setAttribute('value', SLIDER_VALUE_MAPPER[slider.get()]);
    trackFilterEvent('Bonus Points Slider Changed', SLIDER_DISPLAY_MAPPER[slider.get()]);
    $form.submit();
  }

  function sliderSetValue(slider, value, sliderInput) {
    slider.set(SLIDER_VALUE_MAPPER.indexOf(value));
    sliderInput.setAttribute('value', SLIDER_VALUE_MAPPER[slider.get()]);
  }

  function sliderReset(slider, sliderInput) {
    slider.reset();
    sliderInput.setAttribute('value', SLIDER_VALUE_MAPPER[slider.get()]);
  }
}

export { initializeSliderEvents };
